import { userService } from '../_services/user.service';

// Flag to prevent infinite logout loop
let isLoggingOut = false;

/**
 * Zentrale Funktion zum Prüfen auf Unauthorized-Fehler
 * Führt automatisch Logout durch wenn 401 oder "Unauthorized" erkannt wird
 */
export function checkUnauthorized(response, errorMessage = null) {
  // Prüfe Response Status
  if (response && response.status === 401) {
    performLogout();
    return true;
  }
  
  // Prüfe Error Message
  if (errorMessage && (
    errorMessage.includes('Unauthorized') || 
    errorMessage.includes('unauthorized') ||
    errorMessage === 'Unauthorized'
  )) {
    performLogout();
    return true;
  }
  
  return false;
}

/**
 * Führt Logout durch (mit Schutz gegen infinite loops)
 */
function performLogout() {
  if (!isLoggingOut) {
    isLoggingOut = true;
    console.warn('Unauthorized detected - logging out');
    userService.logout().finally(() => {
      isLoggingOut = false;
    });
  }
}

export function handleResponse(response) {
  return response.text().then(text => {
    let data = text && JSON.parse(text);
    if(data.data)
      data = data.data;
    if (!response.ok) {
      if(response.status === 418)
        localStorage.removeItem('user');
      if (response.status >= 401) {
        // auto logout if 401 response returned from api (but avoid infinite loop)
        checkUnauthorized(response);
      }
      // const error = (data && data.message) || response.statusText;
      const error = data.message ? data.message : response.statusText ? response.statusText : response.statusText;
      
      // Prüfe auch die Error-Message auf Unauthorized
      checkUnauthorized(null, error);
      
      return Promise.reject(error);
    }
    return data;
  });
}